import { useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const usePositionApplications = (positionId) => {
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    const fetchApplications = async () => {
      if (!positionId) return

      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_API_AUDIENCE,
          },
        })
        const response = await fetch(`${apiUrl}/api/jobapplications/position/${positionId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        if (response.ok) {
          const data = await response.json()
          setApplications(data)
        } else {
          throw new Error("Failed to fetch applications")
        }
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchApplications()
  }, [positionId, getAccessTokenSilently, apiUrl])

  return { applications, loading, error }
}

